module.exports = __webpack_public_path__ + "img/unnamed.77f0cadf.jpeg";